module.exports = __webpack_public_path__ + "static/media/firma-opi.0368d9c3.png";